import { motion } from 'framer-motion';
import { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { X } from 'lucide-react';

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      url: 'https://images.unsplash.com/photo-1765897569589-effcccec14d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZGllc2VsJTIwZ2VuZXJhdG9yJTIwcG93ZXIlMjBwbGFudCUyMHNpdGV8ZW58MHx8fHwxNzcxOTEzMjM2fDA&ixlib=rb-4.1.0&q=85',
      title: 'Industrial Power Plant Installation',
      category: 'Industrial',
    },
    {
      id: 2,
      url: 'https://images.unsplash.com/photo-1601119462238-d7f347e41844?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHx0ZWNobmljaWFuJTIwcmVwYWlyaW5nJTIwaW5kdXN0cmlhbCUyMGdlbmVyYXRvciUyMHNhZmV0eSUyMGdlYXJ8ZW58MHx8fHwxNzcxOTEzMjM3fDA&ixlib=rb-4.1.0&q=85',
      title: 'Expert Technician Servicing',
      category: 'Maintenance',
    },
    {
      id: 3,
      url: 'https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      title: 'Industrial Equipment Maintenance',
      category: 'Maintenance',
    },
    {
      id: 4,
      url: 'https://images.unsplash.com/photo-1683119926853-6427b2966f9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxsYXJnZSUyMGluZHVzdHJpYWwlMjBkaWVzZWwlMjBnZW5lcmF0b3IlMjBtYWNoaW5lJTIwaXNvbGF0ZWR8ZW58MHx8fHwxNzcxOTEzMjU1fDA&ixlib=rb-4.1.0&q=85',
      title: 'Compact Generator Unit',
      category: 'Products',
    },
    {
      id: 5,
      url: 'https://images.unsplash.com/photo-1704747081666-f4fd33d5db5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxsYXJnZSUyMGluZHVzdHJpYWwlMjBkaWVzZWwlMjBnZW5lcmF0b3IlMjBtYWNoaW5lJTIwaXNvbGF0ZWR8ZW58MHx8fHwxNzcxOTEzMjU1fDA&ixlib=rb-4.1.0&q=85',
      title: 'High Capacity Generator',
      category: 'Products',
    },
    {
      id: 6,
      url: 'https://images.unsplash.com/photo-1769184613636-1b7ba2210932?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwb2ZmaWNlJTIwYnVpbGRpbmclMjBleHRlcmlvciUyMHN1bm55fGVufDB8fHx8MTc3MTkxMzI0N3ww&ixlib=rb-4.1.0&q=85',
      title: 'Commercial Building Installation',
      category: 'Commercial',
    },
    {
      id: 7,
      url: 'https://images.unsplash.com/photo-1765897569589-effcccec14d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZGllc2VsJTIwZ2VuZXJhdG9yJTIwcG93ZXIlMjBwbGFudCUyMHNpdGV8ZW58MHx8fHwxNzcxOTEzMjM2fDA&ixlib=rb-4.1.0&q=85',
      title: 'Large Scale Installation Project',
      category: 'Industrial',
    },
    {
      id: 8,
      url: 'https://images.unsplash.com/photo-1601119462238-d7f347e41844?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHx0ZWNobmljaWFuJTIwcmVwYWlyaW5nJTIwaW5kdXN0cmlhbCUyMGdlbmVyYXRvciUyMHNhZmV0eSUyMGdlYXJ8ZW58MHx8fHwxNzcxOTEzMjM3fDA&ixlib=rb-4.1.0&q=85',
      title: 'Professional Installation Service',
      category: 'Installation',
    },
    {
      id: 9,
      url: 'https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      title: 'Routine Maintenance Check',
      category: 'Maintenance',
    },
  ];

  const categories = ['All', 'Industrial', 'Commercial', 'Products', 'Installation', 'Maintenance'];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredImages =
    activeCategory === 'All'
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeCategory);

  return (
    <div className="pt-20" data-testid="gallery-page">
      <section className="py-20 bg-gradient-to-br from-[#1B365D] to-[#2563eb] text-white noise-overlay" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6" data-testid="gallery-title">
              Project Gallery
            </h1>
            <p className="text-lg sm:text-xl text-slate-200 max-w-3xl mx-auto">
              Explore our successful installations and projects across various industries
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-12 bg-white border-b border-slate-200" data-testid="gallery-filters">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                data-testid={`filter-${category.toLowerCase()}`}
                className={`px-6 py-2 rounded-sm font-semibold uppercase text-sm tracking-wide transition-all ${
                  activeCategory === category
                    ? 'bg-[#F97316] text-white'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50" data-testid="gallery-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredImages.map((image, index) => (
              <motion.div
                key={image.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                className="group relative overflow-hidden rounded-sm shadow-lg cursor-pointer bg-white border border-slate-200 hover:border-[#F97316] transition-all"
                onClick={() => setSelectedImage(image)}
                data-testid={`gallery-item-${index}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <span className="text-[#F97316] text-sm font-semibold uppercase tracking-wide mb-2">
                    {image.category}
                  </span>
                  <h3 className="text-white text-lg font-bold">{image.title}</h3>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={selectedImage !== null} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-5xl p-0 overflow-hidden" data-testid="gallery-lightbox" aria-describedby="gallery-image-description">
          {selectedImage && (
            <div className="relative" id="gallery-image-description">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
                data-testid="lightbox-close"
              >
                <X size={24} />
              </button>
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="w-full h-auto"
              />
              <div className="bg-white p-6">
                <span className="text-[#F97316] text-sm font-semibold uppercase tracking-wide">
                  {selectedImage.category}
                </span>
                <h2 className="text-2xl font-bold text-[#1B365D] mt-2">{selectedImage.title}</h2>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <section className="py-20 bg-white" data-testid="gallery-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-[#1B365D] mb-6" data-testid="gallery-cta-title">
              Want to See Your Project Here?
            </h2>
            <p className="text-lg text-slate-600 mb-8">
              Let us help you with your next generator installation project.
            </p>
            <a
              href="/contact"
              className="bg-[#F97316] hover:bg-[#EA580C] text-white font-semibold py-4 px-10 rounded-sm transition-all uppercase tracking-wide inline-block"
              data-testid="gallery-cta-button"
            >
              Start Your Project
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};